import React, {useEffect, useState} from "react";

const classNames = require('classnames');


export interface optionItem {
    id: number,
    name: string
}

export interface ItemProps {
    name: string,
    options: Array<optionItem>,
    value:Array<number>,
    onChange: (selected: number[]) => void
}

interface FilterProps {
    options: Array<Options>,
    show: boolean,
    onChange: (values: Values) => void,
    onClose: () => void
}

export type Options = {
    name:string,
    options:Array<optionItem>
}

type Values = Array<Array<number>>

function FilterCover({show, options, onChange, onClose}: FilterProps) {
    const [values, setValues] = useState<Values>(Array(options.length).fill([-1]))

    const itemChange = (n: number, active: number) => {
        // if (n === -1) {
        //     const v = [...values]
        //     v[active] = [-1]
        //     setValues(v)
        //     return
        // }
        // const v = [...values]
        // const index = v[active].findIndex(item => item === n)
        //
        // if (index !== -1) {
        //     v[active].splice(index, 1)
        // } else {
        //     v[active].push(n)
        // }
        const v = [...values]
        if(n === -1){
            v[active] = [n]
        }else{
            const l = [... v[active]].filter(m => m> -1)
            const d = l.findIndex(k => k === n)
            if(d === -1){
                l.push(n)
            }else{
                l.splice(d,1)
            }
            v[active] = l
        }


        console.log(v,n,active)
        setValues(v)

    }

    const onConfirm = () => {
        onChange(values)
        onClose()
    }


    const onReset = () => {
        setValues(Array(options.length).fill([-1]))
    }


    return !show ? null : <div className='filter-box' onClick={ onClose }>
        <div className="filter-wrapper" onClick={event => event.stopPropagation()}>
            <div className="filter-list">
                {
                    options.map((item, index) => {
                        return <div className={'filter-item'} key={index}>
                            <p className="name">{item.name}</p>
                            <div className={classNames("options", {'active': values[index].filter(n => n > -1).length > 0})}>
                                {
                                    item.options.map((item) => {
                                        return <p className={classNames({'active': values[index].filter(n => n > -1).includes(item.id)})}
                                                  onClick={() => itemChange(item.id, index)}
                                                  key={item.id}>
                                            {
                                                item.name
                                            }
                                        </p>
                                    })
                                }
                            </div>
                        </div>
                    })
                }
            </div>

            <div className="btns">
                <div className="btn clean" onClick={() => onReset()}>
                    重置
                </div>
                <div className="btn fill" onClick={() => onConfirm()}>
                    确认
                </div>
            </div>
        </div>
    </div>
}

export default FilterCover;
